import styled from 'styled-components';
import { HTMLAttributes, DetailedHTMLProps } from 'react';

interface FirmnessProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  isDual?: boolean;
}

export const Container = styled.div<FirmnessProps>`
  background-color: var(--color-sleepunique-teal);
  border-radius: 0.5625rem;
  color: white;
  padding: var(--spacing-3);
  font-weight: 300;
  display: grid;
  align-items: center;
  justify-items: flex-start;
  grid-column-gap: var(--spacing-2);
  grid-template-columns: 3fr 1fr;

  ${({ theme }) => theme.breakpoints.minBp('tablet')} {
    ${({ isDual }) =>
      isDual
        ? `
        grid-template-rows: repeat(3,1fr);
        grid-template-columns: auto; `
        : `
        grid-template-columns: 2fr auto 2fr;
        grid-column-gap: var(--spacing-6);
      `};
    padding: var(--spacing-4);
    justify-items: center;
  }

  .firmness-card {
    &__icon {
      order: 2;
      grid-row-end: span 2;
      justify-self: center;

      ${({ theme }) => theme.breakpoints.minBp('tablet')} {
        grid-row-end: initial;
      }
    }

    &__title {
      font-size: 1.25rem;
      font-weight: 600;
      order: 1;
      margin: 0 0 var(--spacing-1);
      color: var(--color-sleepunique-lighter-blue);

      ${({ theme }) => theme.breakpoints.minBp('tablet')} {
        font-size: 1.875rem;
        margin: 0;
      }
    }

    &__description {
      margin: 0;
      order: 3;
      font-size: 0.75rem;
      text-align: left;
      line-height: 1;
      color: var(--color-sleepunique-lighter-blue);

      ${({ theme }) => theme.breakpoints.minBp('tablet')} {
        font-size: 0.875rem;
        text-align: center;
      }
    }
  }
`;
